import Link from "next/link"
import Meta from "components/Meta"
import { getGlobals } from "storyblok/api"
import { getPracticeAreas } from "storyblok/practiceAreas"
import { getStoryblokLink } from "utilities/getStoryblokLink"

export default function Sitemap({ story, meta, globals, practiceAreas }) {
  return (
    <>
      {/* <Meta info={meta} /> */}
      <main data-pagefind-body>
        <div className="px-5 py-7">
          <div className="max-w-screen-xl mx-auto">
            <h1 className="text-primary">Sitemap</h1>

            <div className="flex flex-col md:flex-row md:gap-12">
              <div className="lg:basis-1/3">
                {globals?.header?.mainMenu?.map((menu, idx) => (
                  <div key={idx} className="py-4">
                    {menu.nested_menu_items.length < 1 ? (
                      <Link href={getStoryblokLink(menu.link)}>
                        <h2 className="hover:underline">{menu.label}</h2>
                      </Link>
                    ) : (
                      <h2 className="pb-4">{menu.label}</h2>
                    )}
                    <div>
                      {menu.nested_menu_items.map((item, idx) => {
                        return item.nested_menu_items.length ? (
                          <div className="py-4">
                            <h3 className="pb-3">{item.label}</h3>
                            <div className="">
                              {item.nested_menu_items.map((item) => (
                                <Link
                                  href={getStoryblokLink(item.link)}
                                  className="block cursor-pointer hover:underline"
                                  key={item._uid}
                                >
                                  {item.label}
                                </Link>
                              ))}
                            </div>
                          </div>
                        ) : (
                          <Link
                            href={getStoryblokLink(item.link)}
                            key={idx}
                            className="cursor-pointer hover:underline block"
                          >
                            {item.label}
                          </Link>
                        )
                      })}
                    </div>
                  </div>
                ))}

                <div className="py-4">
                  {globals?.header?.sideMenu?.map((item, idx) => {
                    return item.nested_menu_items.length ? (
                      <div className="pb-4">
                        <h3 className="pb-3">{item.label}</h3>
                        {item.nested_menu_items.map((item) => (
                          <Link href={getStoryblokLink(item.link)} className="block hover:underline" key={item._uid}>
                            {item.label}
                          </Link>
                        ))}
                      </div>
                    ) : (
                      <Link href={getStoryblokLink(item.link)} key={idx}>
                        {item.label}
                      </Link>
                    )
                  })}
                </div>
              </div>

              <div className="py-4 lg:basis-2/3">
                <h2>All Practice Areas</h2>
                <div className="lg:columns-2">
                  {practiceAreas.map((practice) => {
                    return practice.childPracticeAreas.length > 0 ? (
                      <div className="py-2" key={practice.name}>
                        <h4 className="pb-1">{practice?.name}</h4>
                        {practice.childPracticeAreas.map((cpa) => (
                          <Link key={cpa.name} className="block hover:underline" href={cpa.full_slug}>
                            {cpa.name}
                          </Link>
                        ))}
                      </div>
                    ) : (
                      <Link href={practice.full_slug}>
                        <h4 className="pb-4 hover:underline">{practice.name}</h4>
                      </Link>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  // home is the default slug for the homepage in Storyblok, but we've aliased it to '/' here and in the visual editor.
  const globals = await getGlobals()
  const practiceAreas = await getPracticeAreas()

  return {
    props: {
      globals,
      practiceAreas: practiceAreas ?? null,
      // meta: page?.content?.twentysixty_seo ?? null,
      preview,
    },
  }
}
